import { List } from 'antd';
import { Modal, Pagination } from 'components/common';
import React, { useState } from 'react';
import { useTicketDetail, useTicketsCompleteCustomerLookupPaging } from 'hooks/tickets';
import ContactCompletedTicketItem from './ContactCompletedTicketItem';
import TicketDetailed from 'components/ticket-detailed/TicketDetailed';

type ContactCompletedTicketTabProps = {
  contactId: number;
  searchCriteria: any;
  handleCustomerCodeClick?: (customerCode: string) => void;
};

const ContactCompletedTicketTab: React.FC<ContactCompletedTicketTabProps> = ({
  contactId,
  searchCriteria,
  handleCustomerCodeClick
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedTicketId, setSelectedTicketId] = useState<number | null>(null);
  const [isSecondCall, setIsSecondCall] = useState(false);

  const showModal = (ticketId: number, secondCall: boolean = false) => {
    setIsModalOpen(true);
    setSelectedTicketId(ticketId);
    setIsSecondCall(secondCall);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setSelectedTicketId(null);
    setIsSecondCall(false);
  };

  const { ticketDetail } = useTicketDetail(selectedTicketId || 0);

  const { count, handleChangePage, isLoading, pageIndex, resetPage, ticketsCompleteCustomerLookup } =
    useTicketsCompleteCustomerLookupPaging({
      administrativeUnitId: searchCriteria.administrativeUnitId,
      contactId
    });

  return (
    <div>
      <div className='flex h-[calc(100vh-242px)] max-h-[calc(100vh-242px)] flex-1 flex-col items-center gap-[22px] overflow-auto pb-5'>
        <List
          className='list-item-hover-animation list-item-hover w-full'
          rowKey={(item) => `contact-customer-${item.ticketId}`}
          dataSource={ticketsCompleteCustomerLookup}
          renderItem={(item) => (
            <ContactCompletedTicketItem
              handleCustomerCodeClick={handleCustomerCodeClick}
              showModal={showModal}
              item={item}
            />
            // <ContactTicketItem isCompleted color='#1564E8' key={item.ticketId} item={item} />
          )}
          loading={isLoading}
        />
        <div className='mt-auto'>
          <Pagination
            count={count}
            loading={isLoading}
            currentPage={pageIndex}
            handleChangePage={(pageIndex: number) => handleChangePage(pageIndex)}
          />
        </div>
      </div>

      <Modal
        className='ant-modal-body-p-none max-h-[1000px] w-[1088px]'
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
        destroyOnClose
        centered
      >
        <TicketDetailed
          status={ticketDetail?.status.code}
          ticketId={selectedTicketId || 0}
          cancelDetailModal={handleCancel}
          isSecondCall={isSecondCall}
        />
      </Modal>
    </div>
  );
};
export default ContactCompletedTicketTab;
